import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/alerts';

export const alertsService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  get: (id) => apiClient.get(`${base}/${id}`),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.put(`${base}/${id}`, payload),
  setStatus: (id, isActive) => apiClient.patch(`${base}/${id}/status`, { isActive }),
  remove: (id) => apiClient.delete(`${base}/${id}`),
};

export default alertsService;
